var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Not found the recipient-no found-person-user-search-searching",
    id: "Not_found_the_recipient-no_found-person-user-search-searching"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.59,57.77l-6-6.38a1.61,1.61,0,0,0-1.19-.51h0a2,2,0,0,0-1.31.54L48,50.28A12.12,12.12,0,0,0,47.7,33.5,12,12,0,0,0,39.17,30a12.15,12.15,0,0,0-3.19.43,20.27,20.27,0,0,0-3.06-1.52c-.47-.18-.94-.33-1.42-.47a13.76,13.76,0,1,0-10.74,0A19.82,19.82,0,0,0,11.84,34,22.54,22.54,0,0,0,6,49.37a.94.94,0,0,0,1.87,0,20.66,20.66,0,0,1,5.39-14.09,17.5,17.5,0,0,1,12.92-5.79,17,17,0,0,1,6.1,1.13,16,16,0,0,1,1.47.65,11.88,11.88,0,0,0-3.07,2.23,12.11,12.11,0,0,0,0,17.1,12,12,0,0,0,16,1l1.19,1.25A1.84,1.84,0,0,0,48,55l6,6.39a1.64,1.64,0,0,0,1.19.5h0a2,2,0,0,0,1.41-.62l.88-.92A1.9,1.9,0,0,0,57.59,57.77Zm-43.34-42A11.89,11.89,0,1,1,26.14,27.62,11.89,11.89,0,0,1,14.25,15.75ZM32,49.27a10.25,10.25,0,0,1,0-14.45,10.18,10.18,0,0,1,14.41,0,10.24,10.24,0,0,1,0,14.45,10.18,10.18,0,0,1-14.41,0Zm24.14,9.8h0l-.9.91-5.81-6.17,0-.08.9-.92L56.15,59A.15.15,0,0,1,56.1,59.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.19,35.62a3.31,3.31,0,0,0-3.3,3.31.94.94,0,1,0,1.87,0,1.43,1.43,0,1,1,1.43,1.44.94.94,0,0,0-.94.93v2.38a.94.94,0,0,0,1.88,0V42.11a3.31,3.31,0,0,0-.94-6.49Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.19,
    cy: 47.23,
    r: 1.18
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserNotFound);
export default __webpack_public_path__ + "static/media/user-not-found.b548bed2b8d74a154e7d451ad9e347af.svg";
export { ForwardRef as ReactComponent };